import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

const IntramuralContacts = () => {
  return (
    <Box id="intramural-contacts">
      <Typography
        align="center"
        sx={{
          fontSize: { xs: "20px", sm: "24px", md: "30px" },
          mt: 4,
          mb: 4,
          p: 2,
          border: "1px dotted #00001c",
          color: 'rgba(0, 6, 58, 1)'
        }}
      >
        INTRAMURAL CONTACTS
      </Typography>

      <Paper sx={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Location</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Selden</TableCell>
              <TableCell>Kim Onek</TableCell>
              <TableCell>Bav2828@yahoo.com</TableCell>
            </TableRow>
            {/* <TableRow>
              <TableCell>Stony Brook</TableCell>
              <TableCell>Kim Onek</TableCell>
              <TableCell>Bav2828@yahoo.com</TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell>Centereach</TableCell>
              <TableCell>Frank Rudilosso</TableCell>
              <TableCell>Frank@mccsoccer.org</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default IntramuralContacts;
